module.exports = __webpack_public_path__ + "static/media/bgEventclub.7b47fd83.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/bgEventclub.png
// module id = 1291
// module chunks = 0